var _rect, _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _path6, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriverCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#D77910"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.0277 11.542V16.0345C19.0277 18.1045 17.3477 19.7845 15.2777 19.7845H8.72266C6.65266 19.7845 4.97266 18.1045 4.97266 16.0345V11.5945C5.54266 12.2095 6.35266 12.562 7.23016 12.562C8.17516 12.562 9.08266 12.0895 9.65266 11.332C10.1627 12.0895 11.0327 12.562 12.0002 12.562C12.9602 12.562 13.8152 12.112 14.3327 11.362C14.9102 12.1045 15.8027 12.562 16.7327 12.562C17.6402 12.562 18.4652 12.1945 19.0277 11.542Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2415 3.9375H9.74153L9.18653 9.4575C9.14153 9.9675 9.21653 10.4475 9.40403 10.8825C9.83903 11.9025 10.859 12.5625 11.999 12.5625C13.154 12.5625 14.1515 11.9175 14.6015 10.89C14.7365 10.5675 14.819 10.1925 14.8265 9.81V9.6675L14.2415 3.9375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M19.7703 9.2025L19.5528 7.125C19.2378 4.86 18.2103 3.9375 16.0128 3.9375H13.1328L13.6878 9.5625C13.6953 9.6375 13.7028 9.72 13.7028 9.8625C13.7478 10.2525 13.8678 10.6125 14.0478 10.935C14.5878 11.925 15.6378 12.5625 16.7328 12.5625C17.7303 12.5625 18.6303 12.12 19.1928 11.34C19.6428 10.74 19.8453 9.9825 19.7703 9.2025Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M7.94224 3.9375C5.73724 3.9375 4.71724 4.86 4.39474 7.1475L4.19224 9.21C4.11724 10.0125 4.33474 10.7925 4.80724 11.4C5.37724 12.1425 6.25474 12.5625 7.22974 12.5625C8.32474 12.5625 9.37474 11.925 9.90724 10.95C10.1022 10.6125 10.2297 10.2225 10.2672 9.8175L10.8522 3.945H7.94224V3.9375Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5123 15.4952C10.5598 15.5927 9.83984 16.4027 9.83984 17.3627V19.7852H14.1523V17.6252C14.1598 16.0577 13.2373 15.3152 11.5123 15.4952Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EB5757"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 7.54545,
    cy: 15.0005,
    r: 2.54545,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 16.4537,
    cy: 15.0005,
    r: 2.54545,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2953 10.7921C15.4808 11.0239 15.8054 11.0471 16.0373 10.8848C16.2691 10.6993 16.2923 10.3747 16.13 10.1429L14.1592 7.63874L14.1128 7.59237C13.881 7.36051 13.5564 7.31414 13.2781 7.45325L10.5885 9.02992C10.403 9.14585 10.2639 9.33134 10.2407 9.54001C10.2175 9.74869 10.2871 9.93418 10.4262 10.0965L11.3073 11.1167C11.4232 11.2558 11.4928 11.4413 11.4928 11.65V13.2034C11.4928 13.4817 11.7246 13.7367 12.0261 13.7367C12.3043 13.7367 12.5593 13.5049 12.5593 13.2034V11.65C12.5593 11.2094 12.397 10.7689 12.1188 10.4443L11.4928 9.7255L13.5332 8.51982L15.2953 10.7921Z",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 15.8176,
    cy: 6.09109,
    r: 1.27273,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverCancel);
export default __webpack_public_path__ + "static/media/driver_cancel.ca3bcb1a391721b647a00c862035d7ca.svg";
export { ForwardRef as ReactComponent };